"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScrollToTopRouteWatcher = void 0;
const react_1 = require("react");
const react_router_1 = require("react-router");
const Component = ({ history }) => {
    (0, react_1.useEffect)(() => {
        const unlisten = history.listen(() => {
            console.log("Scrolling up");
            window.scrollTo(0, 0);
        });
        return () => {
            unlisten();
        };
    }, []);
    return null;
};
exports.ScrollToTopRouteWatcher = (0, react_router_1.withRouter)(Component);
